import React from 'react';
import {t} from 'i18next';
import {TranscodeService} from '../../services/transcode.service';
import {BreadcrumbsDTO} from '../../models/dto/BreadcrumbsDTO';
import {BreadcrumbContainer, BreadcrumbElement} from './Breadcrumb.style';

export interface BreadcrumbProps {
    readonly breadcrumbs: BreadcrumbsDTO[];
    readonly breadcrumbPath: BreadcrumbPaths;
    onPathClicked: (path: string) => void;
}

export enum BreadcrumbPaths {
    HOME = 'HOME',
    FILTERED = 'FILTERED',
    RECENTLY_ADDED = 'RECENTLY_ADDED',
    FAVORITES = 'FAVORITES',
    PUBLIC_ACCESS = 'PUBLIC_ACCESS'
}

export const Breadcrumb: React.VFC<BreadcrumbProps> = (props) => {
    const handlePathClicked = (path: BreadcrumbsDTO) => {
        let clickedPathIndex = props.breadcrumbs.indexOf(path);
        let newPath = props.breadcrumbs.slice(0, clickedPathIndex + 1).map(obj => obj.storagePathPart);
        props.onPathClicked('/' + newPath.join('/'));
    };

    const handleRootClicked = () => {
        props.onPathClicked('/');
    };

    const getBreadcrumbPathElement = () => {
        switch (props.breadcrumbPath) {
            case BreadcrumbPaths.HOME:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_HOME')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.FILTERED:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_FILTERED')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.RECENTLY_ADDED:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_RECENTLY_ADDED')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.FAVORITES:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_FAVORITES')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.PUBLIC_ACCESS:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('PUBLIC_ACCESS')}
                    </BreadcrumbElement>
                );
            default:
                return (
                    <BreadcrumbElement key={'home'} onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_HOME')}
                    </BreadcrumbElement>
                );
        }
    };

    return (
        <BreadcrumbContainer>
            {t('BREADCRUMB_PATH')}
            {getBreadcrumbPathElement()}
            {props.breadcrumbs.map(path => (
                <span key={TranscodeService.decodeString(path.labelPathPart)}>
                    {'/'}
                    <BreadcrumbElement key={TranscodeService.decodeString(path.labelPathPart)}
                                       onClick={() => handlePathClicked(path)}>
                        {TranscodeService.decodeString(path.labelPathPart)}
                    </BreadcrumbElement>
                </span>
            ))}
        </BreadcrumbContainer>
    );
};
